



























































































































import {Component, Vue} from 'vue-property-decorator';
import ProfileEditDialog from '@/views/user/ProfileEditDialog.vue';
import AskConfirmationDialog from '@/components/AskConfirmationDialog.vue';
import userProfileModule from '@/store/modules/userProfileModule';
import {UserData, SessionData, LoginHistoryItem} from '@/views/user/interfaces';
import Loading from '@c/controls/Loading.vue';
import userSettingsModule from '@/store/modules/userSettingsModule';

@Component({components: {ProfileEditDialog, AskConfirmationDialog, Loading}})
export default class ProfileView extends Vue {
  data: UserData | null = null;

  model: any = null;

  dialog = false;

  activeTab = 0;

  loading = true;
  error = false;

  showMainMenu: boolean | null = null;

  sessions: SessionData[] | null = null;
  sessionsLoading = true;
  sessionsError = false;

  sessionHeaders = [
    {text: 'Id', value: 'id'},
    {text: 'IP-адрес', value: 'ip_address'},
    {text: 'Время жизни', value: 'timetolive'},
    {text: 'Браузер', value: 'browser'},
    {text: 'Действия', value: 'actions', sortable: false},
  ];

  loginHistoryItems: LoginHistoryItem[] = [];
  loginLoading = true;
  loginError = false;
  loginPage = 1;
  loginItemsPerPage = 10;

  loginFilterStartDate = '';
  loginFilterEndDate = '';
  loginFilterSuccess: boolean | '' = '';
  loginFilterIP = '';

  loginHistoryHeaders = [
    {text: 'Время', value: 'timestamp'},
    {text: 'IP-адрес', value: 'ip_address'},
    {text: 'Браузер', value: 'browser'},
    {text: 'Статус', value: 'is_success', sortable: false},
  ];

  get sessionsCount(): number {
    return this.sessions ? this.sessions.length : 0;
  }

  async created() {
    try {
      this.loading = true;
      this.data = await userProfileModule.get();
      const mainMenuSettings = localStorage.getItem('mainMenuSettings');
      if (mainMenuSettings) this.showMainMenu = JSON.parse(mainMenuSettings).showMainMenu;
      this.loading = false;
    } catch {
      this.error = true;
    }
    this.fetchSessions();
    this.fetchLoginHistory();
  }

  openEditDialog() {
    if (this.data) {
      const dialog = this.$refs.editDialog as any;
      this.model = {userInfo: {...this.data}, showMainMenu: this.showMainMenu};
      dialog.open(this.model);
    }
  }

  async fetchSessions() {
    this.sessionsLoading = true;
    this.sessionsError = false;
    try {
      this.sessions = await userProfileModule.list_sessions();
    } catch {
      this.sessionsError = true;
    } finally {
      this.sessionsLoading = false;
    }
  }

  async closeSession(item: SessionData) {
    try {
      await userProfileModule.close_session(item.sign);
      this.sessions = await userProfileModule.list_sessions();
    } catch {
      // error handled by global interceptor
    }
  }

  async closeAllSessions() {
    try {
      await userProfileModule.close_session('');
      this.sessions = await userProfileModule.list_sessions();
    } catch {
      // error handled by global interceptor
    }
  }

  askConfirmCloseAll() {
    const dlg = this.$refs.confirmDlg as any;
    dlg.open('Вы уверены, что хотите закрыть все сеансы?', 'Да');
  }

  onConfirmAnswer(confirmed: boolean) {
    if (confirmed) {
      this.closeAllSessions();
    }
  }

  buildLoginHistoryParams() {
    //Клиентская пагинация: сразу грузим весь набор (лимит 1000), v-data-table сам листает страницы.
    //Сервер не возвращает total — «вперёд» на серверной пагинации работать не может.
    const params: any = {limit: 1000};
    if (this.loginFilterStartDate) {
      params.start_date = new Date(this.loginFilterStartDate).getTime();
    }
    if (this.loginFilterEndDate) {
      params.end_date = new Date(this.loginFilterEndDate).getTime() + 24 * 60 * 60 * 1000 - 1;
    }
    if (this.loginFilterSuccess === true || this.loginFilterSuccess === false) {
      params.is_success = this.loginFilterSuccess;
    }
    if (this.loginFilterIP) {
      params.ip_address = this.loginFilterIP;
    }
    return params;
  }

  async fetchLoginHistory() {
    this.loginLoading = true;
    this.loginError = false;
    try {
      this.loginHistoryItems = await userProfileModule.get_login_history(
        this.buildLoginHistoryParams(),
      );
    } catch {
      this.loginError = true;
    } finally {
      this.loginLoading = false;
    }
  }

  applyLoginFilters() {
    this.loginPage = 1;
    this.fetchLoginHistory();
  }

  resetLoginFilters() {
    this.loginFilterStartDate = '';
    this.loginFilterEndDate = '';
    this.loginFilterSuccess = '';
    this.loginFilterIP = '';
    this.loginPage = 1;
    this.fetchLoginHistory();
  }

  formatLoginTs(ts: number | undefined | null): string {
    if (!ts) return '';
    const ms = ts < 1e12 ? ts * 1000 : ts;
    return new Date(ms).toLocaleString('ru-RU');
  }

  handleValidationErrors(detail: any[]) {
    return detail.reduce((obj, err) => {
      const key = err.loc[0] === 'body' ? err.loc[1] : err.loc[0];
      obj[`${key}ValidationError`] = err.msg;
      return obj;
    }, {});
  }

  async onSubmit() {
    if (!this.model) return;
    this.model.userInfo.password = this.model.userInfo.password || undefined;
    const dialog = this.$refs.editDialog as any;
    try {
      await userProfileModule.save(this.model.userInfo);
      this.data = await userProfileModule.get();

      userSettingsModule.setMainMenuSettings({showMainMenu: this.model.showMainMenu});
      const mainMenuSettings = localStorage.getItem('mainMenuSettings');
      if (mainMenuSettings) this.showMainMenu = JSON.parse(mainMenuSettings).showMainMenu;

      dialog.$refs.form.reset();
      dialog.close();
    } catch (e) {
      if (e?.response.status === 400) {
        dialog.setupErrors(e.response.data.detail);
      } else if (e?.response.status === 422) {
        dialog.setupErrors(this.handleValidationErrors(e.response.data.detail));
      } else dialog.setupErrors({error: 'Произошла ошибка'});
    }
  }
}
